/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Teams_BlurbInputs */



/**
* | output |
* | --- |
* | "Teams group users so you can manage access together. Grant a team access to spaces and projects, and assign shared model access, instead of configuring each ..." |
*
* @param {Uno_Edu_Intro_Teams_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_teams_blurb = /** @type {((inputs?: Uno_Edu_Intro_Teams_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Teams_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams gruppieren Benutzer, damit Sie den Zugriff gemeinsam verwalten können. Gewähren Sie einem Team Zugriff auf Spaces und Projekte und weisen Sie gemeinsamen Modellzugriff zu, statt jede Person einzeln zu konfigurieren.")
	return /** @type {LocalizedString} */ ("Teams group users so you can manage access together. Grant a team access to spaces and projects, and assign shared model access, instead of configuring each person.")
});